import { object, string } from 'yup';

import { stringValidation } from 'src/services/validation';

const mustBeFilledWhenBus = (status, validate = stringValidation) =>
  string().when('busStatus', {
    is: (value) => value === status,
    then: validate(),
    otherwise: string(),
  });

const filingInfoSchema = object().shape({
  paperlessFlag: stringValidation(),
  bypassItemization: stringValidation(),
  busStatus: stringValidation(),
  soldEquipTo: mustBeFilledWhenBus('sold'),
  dateBusSold: mustBeFilledWhenBus('sold'),
  busSameLoc: mustBeFilledWhenBus('sold'),
  newBusLicDate: mustBeFilledWhenBus('sold'),
  equipGoneTo: mustBeFilledWhenBus('closed'),
  dateBusClosed: mustBeFilledWhenBus('closed'),
  busLicCancelDate: mustBeFilledWhenBus('closed'),
  busCity: mustBeFilledWhenBus('moved'),
  busZip: mustBeFilledWhenBus('moved'),
  busLoc: mustBeFilledWhenBus('moved'),
  dateBusMoved: mustBeFilledWhenBus('moved'),
  bankruptcyType: mustBeFilledWhenBus('bankrupt'),
  bankruptcyState: string().when('busStatus', {
    is: (value) => value === 'bankrupt',
    then: stringValidation({ max: 2 }),
    otherwise: string().nullable(),
  }),
  busInOper: mustBeFilledWhenBus('bankrupt'),
  bankruptcyCaseno: mustBeFilledWhenBus('bankrupt'),
  bankruptcyDate: mustBeFilledWhenBus('bankrupt'),
});

export default filingInfoSchema;
